import { Box, Text } from '@zillow/constellation-10';
import { isToday } from 'date-fns';
import type { HeaderProps } from 'react-big-calendar';

const DateHeader = (props: HeaderProps) => {
  const [number, day] = props.label.split(' ');
  const isCurrentDay = isToday(props.date);
  return (
    <Box
      css={{ display: 'flex', flexDirection: 'column', marginBottom: 'tighter', marginTop: 'tighter' }}
      aria-label={`${day} ${number}`}
    >
      <Text css={{ color: isCurrentDay ? '{colors.blue.600}' : 'textMedium' }} textStyle="body-xs">
        {String(day).toUpperCase()}
      </Text>
      <Text css={{ color: isCurrentDay ? '{colors.blue.600}' : '{colors.black}' }} textStyle="body-bold">
        {number}
      </Text>
    </Box>
  );
};

export default DateHeader;
